import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { TUpdateProfile, TChangeProfilePassword } from './profile.types.ts';
import type { TUser, TProfile } from '@/services/auth/auth.types.ts';

export const profileApi = {
  getUserProfile: async () => {
    const response = await axios.get<TUser>(`profile`);

    return response.data;
  },
  updateProfile: async (profile: TUpdateProfile) => {
    const response = await axios.patch<TProfile>(`profile`, profile);

    return response.data;
  },
  changeProfilePassword: async (password: TChangeProfilePassword) => {
    const response = await axios.patch<{ message: string }>(`profile/change-password`, password);

    return response.data;
  },
};

export const profileQueries = createQueryKeys('profile', {
  getUserProfile: () => ({
    queryKey: ['info'],
    queryFn: profileApi.getUserProfile,
  }),
});
